import * as dc from "@/components/layout/list/defaultType";
import { DataColumnField, DataColumnRecord } from "../input/inputType";
import { Debug } from "@/util/debug";
import { RefObject } from "react";
import { FormInstance } from "antd";
import { checkEmpty } from "@/util/stringutil";
import { runFormFunction } from "../input/inputFunction";
export const coffeebean_region: DataColumnRecord = {};
export const coffeebean_select_list = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  locale: string | undefined,
): DataColumnRecord => {
  return {
    coffeebean_country_map: {
      ...dc.geoMapCountryChart("coffeebean_country_list", true),
    },
    coffeebean_country_list: {
      ...dc.geoMapCountryList(formFunction, "coffeebean_country_map", locale, true),
      selectFilter: "CFPRDC",
      dataProp: {
        load: () => {
          if (form?.current) {
            const countryList = form.current.getFieldValue("coffeebean_country_list");
            Debug("coffeebean_region_seq", countryList);
            if (countryList !== undefined && countryList.length === 1) {
              form.current.setFieldValue("coffeebean_country_code", countryList[0]);
              runFormFunction(formFunction, "coffeebean_region_seq", "changeLoad", false);
              runFormFunction(formFunction, "coffeebean_farm_seq", "changeLoad", false);
            }
          }
        },
      },
    },
    coffeebean_country_code: {
      ...dc.coffee_country,
      label: "country_label",
      itemClassName: "hidden",
      noItem: false,
      inputType: "selectSearch",
    },
    coffeebean_region_seq: {
      ...dc.selectSearch,
      read: { show: "notNull", selectProp: { mode: "multiple" } },
      inputClassName: dc.inputCountryClassName,
      selectPropOption: { reloadButton: true },
      selectChangeLoad: "coffeebean_farm_seq",
      inputDirect: { target: "coffeebean_region_etc", query: ".coffeebean_region_etc_item" },
      dataUrl: "/api/code/region",
      noItem: false,
      dataProp: {
        fixedParam: { is_parent: false },
        valueParam: { region_country: "coffeebean_country_code" },
        requiredParam: ["region_country"],
        userAuth: false,
        // load: () => {
        //   const value = form?.current?.getFieldValue("coffeebean_region_seq");
        //   const countryList = form?.current?.getFieldValue("coffeebean_country_list");
        //   Debug("coffeebean_region_seq", value, countryList);
        //   if (!checkEmpty(value) && countryList !== undefined && countryList.length === 1) {
        //   }
        // },
      },
      dataLabel: {
        value: "region_seq",
        label: [
          { field: "region_name_locale", subs: "region_nick_locale" },
          { field: "region_name", subs: "region_nick" },
        ],
      },
    },
    coffeebean_region_etc: {
      ...dc.inputFull,
      itemClassName: "coffeebean_region_etc_item",
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "coffeebean_region_seq",
    },
    coffeebean_farm_seq: {
      ...dc.selectSearch,
      read: { show: "notNull", selectProp: { mode: "multiple" } },
      inputClassName: dc.inputCountryClassName,
      inputDirect: { target: "coffeebean_farm_etc", query: ".coffeebean_farm_etc_item" },
      dataUrl: "/api/code/farm",
      dataProp: {
        valueParam: { region_country: "coffeebean_country_code", farm_region_seq: "coffeebean_region_seq" },
        requiredParam: ["region_country"],
        userAuth: false,
      },
      dataLabel: {
        value: "farm_seq",
        label: ["farm_name_locale", "farm_name"],
        labelSort: false,
      },
    },
    coffeebean_farm_etc: {
      ...dc.inputFull,
      itemClassName: "coffeebean_farm_etc_item",
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "coffeebean_farm_seq",
    },
    coffeebean_grade_list: { ...dc.grade, selectProp: { mode: "multiple" } },
    coffeebean_grade_detail_list: { ...dc.gradeDetail, selectProp: { mode: "multiple" } },
    coffeebean_variety_list: {
      ...dc.varietyMulti,
      selectProp: { mode: "multiple" },
      inputDirect: { target: "coffeebean_variety_etc", query: ".coffeebean_variety_etc_item" },
      read: {
        onClick: dc.clickDefault(
          (e: any) => {
            //alert(e);
          },
          () => {
            //alert("해당 품종에 대한 정보가 없습니다.");
          },
        ),
      },
    },
    coffeebean_variety_etc: {
      ...dc.inputFull,
      itemClassName: "coffeebean_variety_etc_item",
      minLength: 3,
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "coffeebean_variety_list",
    },
    coffeebean_process_list: {
      ...dc.process,
      label: "process_label",
      selectProp: { mode: "multiple" },
      inputDirect: { target: "coffeebean_process_etc", query: ".coffeebean_process_etc_item" },
    },
    coffeebean_process_etc: {
      ...dc.inputFull,
      itemClassName: "coffeebean_process_etc_item",
      minLength: 3,
      maxLength: 300,
      showCount: true,
      label: "blank",
      labelClassName: dc.mobileHidden,
      placeholder: "process_label",
    },
  };
};

export const cafe_public_stage: DataColumnRecord = {
  public_stage_explain: {
    label: "public_stage",
    labelClassName: dc.mobileShow,
    fieldId: {
      public_stage_cafe: {
        ...dc.number,
        placeholder: "public_stage_cafe",
        saveData: false,
        allowClear: false,
        inputClassName: dc.inputAuthWidth + " input-text-center",
        disabled: true,
        readOnly: true,
        variant: "borderless",
        noItem: true,
      },
      public_stage_customer: {
        ...dc.number,
        placeholder: "public_stage_customer",
        saveData: false,
        allowClear: false,
        inputClassName: dc.inputAuthWidth + " input-text-center",
        disabled: true,
        readOnly: true,
        variant: "borderless",
        noItem: true,
      },
      public_stage_normal: {
        ...dc.number,
        placeholder: "public_stage_normal",
        saveData: false,
        allowClear: false,
        inputClassName: dc.inputAuthWidth + " input-text-center",
        disabled: true,
        readOnly: true,
        variant: "borderless",
        noItem: true,
      },
    },
  },
  public_stage: {
    labelClassName: dc.mobileHidden,
    fieldId: {
      public_stage_cafe: {
        ...dc.select,
        inputClassName: dc.inputAuthWidth,
        codeGroup: "PBST",
        selectPropOption: { reloadButton: false },
        create: { defaultValue: "DTL" },
        read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
      },
      public_stage_customer: {
        ...dc.select,
        inputClassName: dc.inputAuthWidth,
        codeGroup: "PBST",
        selectPropOption: { reloadButton: false },
        create: { defaultValue: "NRML" },
        read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
      },
      public_stage_normal: {
        ...dc.select,
        inputClassName: dc.inputAuthWidth,
        codeGroup: "PBST",
        selectPropOption: { reloadButton: false },
        create: { defaultValue: "LST" },
        read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
      },
    },
  },
};
